<div class="w-screen bg-[#9372f6] h-[40px] flex items-center pl-8 justify-start text-white">
    <span class="material-symbols-outlined rounded-full bg-[#9f8fd2] ring ring-[#9f8fd2] mr-4 hover:cursor-pointer"
          (click)="backStep()"
    >arrow_back</span>
    <span class="mr-4">{{position()}} de {{length()}}</span>
    <span class="mr-4 opacity-40"> | </span>
    <span class="mr-4">{{title()}}</span>
</div>
